import { Add16 } from "@carbon/icons-react";
import { Spin } from "antd";
import {
  EmailRemindConfig,
  EmailRemindConfigFilter,
} from "models/EmailRemindConfig";
import { IdFilter } from "react3l-advanced-filters";
import {
  AdvanceIdFilterMaster,
  Button,
  InputSearch,
  Pagination,
  StandardTable,
  TagFilter,
} from "react3l-ui-library";
import { emailRemindConfigRepository } from "repositories/email-remind-config-repository";
import nameof from "ts-nameof.macro";
import useEmailRemindConfigMasterHook from "./EmailRemindConfigMasterHook";

function EmailRemindConfigMaster() {
  const {
    translate,
    handleChangeSelectFilter,
    handleChangeInputSearch,
    handleTableChange,
    handlePagination,
    handleChangeAllFilter,
    validAction,
    filter,
    selectedRowKeys,
    columns,
    list,
    count,
    loadingList,
    handleGoCreate,
  } = useEmailRemindConfigMasterHook();

  return (
    <Spin spinning={false}>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-component ml-4 mb-3">
          <span>{translate("emailRemindConfig.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("emailRemindConfig.master.subHeader")}
          </span>
        </div>

        <div className="page page-master m-b--xxs">
          <div className="pb-3 ml-3 pt-4">
            <h5 className="font-bold page-title">
              {translate("emailRemindConfig.master.subHeader")}
            </h5>
          </div>

          <div className="page-master__content">
            <div className="page-master__tag-filter">
              <TagFilter
                value={filter}
                translate={translate}
                keyTranslate={"emailRemindConfig"}
                handleChangeFilter={handleChangeAllFilter}
                onClear={() => {
                  return 0;
                }}
              />
            </div>
            {(!selectedRowKeys || selectedRowKeys?.length === 0) && (
              <div className="page-master__filter-wrapper d-flex align-items-center justify-content-between px-3">
                <div className="page-master__filter d-flex align-items-center justify-content-start">
                  <div className="">
                    <AdvanceIdFilterMaster
                      value={filter?.applyFunctionId?.equal}
                      placeHolder={translate(
                        "emailRemindConfig.placeholder.reminderType"
                      )}
                      classFilter={EmailRemindConfigFilter}
                      searchProperty={"search"}
                      searchType={""}
                      onChange={handleChangeSelectFilter({
                        fieldName: "applyFunction",
                        fieldType: "equal",
                        classFilter: IdFilter,
                      })}
                      getList={emailRemindConfigRepository.filter}
                      render={(item: EmailRemindConfig) => item?.name}
                      label={translate("emailRemindConfig.reminderType")}
                    />
                  </div>
                </div>
                <div className="page-master__filter-action-search d-flex align-items-center">
                  <InputSearch
                    value={filter.search}
                    classFilter={EmailRemindConfigFilter}
                    placeHolder={translate("general.placeholder.search")}
                    onChange={handleChangeInputSearch}
                  />
                </div>
                <div className="page-master__actions  d-flex align-items-center justify-content-start">
                  <div className="page-master__filter-action d-flex align-items-center">
                    {validAction("create") && (
                      <Button
                        type="primary"
                        className="btn--lg btn-orange-wIcon ml-3"
                        icon={<Add16 />}
                        onClick={handleGoCreate}
                      >
                        {translate("general.actions.create")}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="page-master__content-table">
            <StandardTable
              rowKey={nameof(list[0].id)}
              columns={columns}
              dataSource={list}
              isDragable={true}
              tableSize={"md"}
              onChange={handleTableChange}
              spinning={loadingList}
              scroll={{ x: 1000 }}
            />
            <Pagination
              skip={filter?.skip}
              take={filter?.take}
              total={count}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default EmailRemindConfigMaster;
